import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["hasAllSelect", "label", "options", "handleOnChange", "filterKey"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.join.js";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from "react";
import { Select, Typography, RaiseColors, useTheme } from "componentLibrary";
import FieldBase from "componentLibrary/Fields/FieldBase";
import { CheckBoxGroup } from "componentLibrary/FilterPopper/CheckboxFilterGroup";
import TextLink from "componentLibrary/TextLink/TextLink";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CheckboxGroupBaseField = function CheckboxGroupBaseField(_ref) {
  var _windowSize$innerWidt, _options$filter;
  var hasAllSelect = _ref.hasAllSelect,
    label = _ref.label,
    selectedValues = _ref.selectedValues,
    handleOnChange = _ref.handleOnChange,
    emptyInputText = _ref.emptyInputText,
    allSelectedText = _ref.allSelectedText,
    options = _ref.options,
    children = _ref.children;
  var ClearAll = function ClearAll() {
    var syntheticEvent = {
      target: {
        value: []
      }
    };
    return /*#__PURE__*/_jsx(TextLink, {
      onClick: function onClick() {
        handleOnChange(syntheticEvent);
      },
      children: "Clear all"
    });
  };
  var SelectAll = function SelectAll() {
    var _context;
    var syntheticEvent = {
      target: {
        value: _mapInstanceProperty(_context = _filterInstanceProperty(options).call(options, function (item) {
          return !(item !== null && item !== void 0 && item.isDisabled);
        })).call(_context, function (item) {
          return item === null || item === void 0 ? void 0 : item.id;
        })
      }
    };
    return /*#__PURE__*/_jsx(TextLink, {
      onClick: function onClick() {
        handleOnChange(syntheticEvent);
      },
      children: "Select all"
    });
  };
  var displayButton = (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) === (options === null || options === void 0 ? void 0 : options.length) ? /*#__PURE__*/_jsx(ClearAll, {}) : /*#__PURE__*/_jsx(SelectAll, {});
  var theme = useTheme();
  var windowSize = useWindowSize();
  var windowWidth = (_windowSize$innerWidt = windowSize.innerWidth) !== null && _windowSize$innerWidt !== void 0 ? _windowSize$innerWidt : 0;
  var isTablet = windowWidth <= _valuesInstanceProperty(theme.breakpoints).tablet;
  var isPhone = windowWidth <= _valuesInstanceProperty(theme.breakpoints).smMd;
  var isTV = windowWidth > _valuesInstanceProperty(theme.breakpoints).laptopDefault;
  var paperHeight = "292px";
  if (isPhone) paperHeight = "372px";else if (isTablet || isTV) paperHeight = "492px";
  var checkedLabelsString = options === null || options === void 0 || (_options$filter = _filterInstanceProperty(options).call(options, function (item) {
    return item.isChecked;
  }) // Get only checked items
  ) === null || _options$filter === void 0 || (_options$filter = _mapInstanceProperty(_options$filter).call(_options$filter, function (item) {
    return item.label;
  }) // Extract labels
  ) === null || _options$filter === void 0 ? void 0 : _options$filter.join(", ");
  var displayLabel = "";
  if ((selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) === (options === null || options === void 0 ? void 0 : options.length)) {
    displayLabel = allSelectedText;
  } else if ((selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) === 0) {
    displayLabel = emptyInputText;
  } else {
    displayLabel = (checkedLabelsString === null || checkedLabelsString === void 0 ? void 0 : checkedLabelsString.length) > 30 ? _sliceInstanceProperty(checkedLabelsString).call(checkedLabelsString, 0, 30) + "..." : checkedLabelsString;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      weight: "medium",
      style: {
        marginBottom: "8px"
      },
      component: "div",
      children: label
    }), /*#__PURE__*/_jsx(FieldBase, {
      fullWidth: true,
      InputLabelProps: {
        style: {
          position: "static"
        }
      },
      children: /*#__PURE__*/_jsxs(Select, {
        style: {
          height: "100%",
          textAlign: "left",
          backgroundColor: RaiseColors.white,
          border: "none",
          borderRadius: "8px"
        },
        MenuProps: {
          disablePortal: true,
          PaperProps: {
            onMouseDown: function onMouseDown(event) {
              event.preventDefault();
            },
            style: {
              borderRadius: "16px",
              marginTop: "8px",
              marginBottom: "8px",
              padding: "8px 16px 8px 24px",
              overflow: "scroll",
              maxHeight: paperHeight
            }
          },
          keepMounted: true
        },
        multiple: true,
        displayEmpty: true,
        value: selectedValues,
        onChange: function onChange() {},
        renderValue: function renderValue() {
          return /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            color: RaiseColors.jllNeutral900,
            children: displayLabel
          });
        },
        children: [hasAllSelect ? /*#__PURE__*/_jsx("div", {
          style: {
            display: "flex",
            justifyContent: "end",
            marginBottom: "4px",
            padding: "8px"
          },
          children: displayButton
        }) : null, children]
      })
    })]
  });
};
var CheckboxGroupField = function CheckboxGroupField(_ref2) {
  var hasAllSelect = _ref2.hasAllSelect,
    label = _ref2.label,
    options = _ref2.options,
    handleOnChange = _ref2.handleOnChange,
    filterKey = _ref2.filterKey,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsx(CheckboxGroupBaseField, _objectSpread(_objectSpread({
    label: label,
    options: options,
    handleOnChange: handleOnChange,
    hasAllSelect: hasAllSelect
  }, props), {}, {
    children: /*#__PURE__*/_jsx(CheckBoxGroup, {
      filterName: label,
      checkboxGroupElements: options,
      onChange: function onChange(event) {
        return handleOnChange(event, filterKey);
      }
    })
  }));
};
export default CheckboxGroupField;